module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_see_all_trainings")))])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/waiting_list.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.currentDate) + " - " + _vm._s(_vm.startAtTime))])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.trainings), function(item) {
    return _c('div', {
      staticClass: "training-item-column whole",
      staticStyle: {
        "background-color": "transparent",
        "height": "50px !important",
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      staticClass: "training-item-column-inner whole",
      staticStyle: {
        "height": "50px !important"
      }
    }, [_c('div', {
      staticClass: "my-training-item"
    }, [_c('div', [_c('p', {
      staticClass: "my-training-item-text-title"
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "my-training-item-text-training-type"
    }, [_vm._v(_vm._s(item.trainingType))])])])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3e12168!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/SeeTrainingsModal.vue
// module id = 848
// module chunks = 0